import { render, staticRenderFns } from "./button-action-ribbon-menu-more.vue?vue&type=template&id=a193bf80&scoped=true&"
import script from "./button-action-ribbon-menu-more.vue?vue&type=script&lang=js&"
export * from "./button-action-ribbon-menu-more.vue?vue&type=script&lang=js&"
import style0 from "./button-action-ribbon-menu-more.vue?vue&type=style&index=0&id=a193bf80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a193bf80",
  null
  
)

export default component.exports